<template>
  <div class="cont" id="brake4">
    <div class="inner">
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:32px;width:150px;margin-left:38px;margin-bottom:13px"
        :src="require('@/assets/image/brake/brake4/img1.png')"
        :fit="fit"
      ></el-image>
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:16px;width:206px;margin-left:24px;margin-bottom:30px"
        :src="require('@/assets/image/brake/brake4/img2.png')"
        :fit="fit"
      ></el-image>
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:26px;width:121px;margin-left:0px;margin-bottom:0px"
        :src="require('@/assets/image/brake/brake4/img3.png')"
        :fit="fit"
      ></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContFour",
  data() {
    return {
      fit: "cover",
      animate: false,
      screenHeight: window.innerHeight || document.documentElement.clientHeight
    };
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    var topPos = document.getElementById("brake4").offsetTop;
    if (scrollTop + this.screenHeight > topPos) {
      this.animate = true;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var topPos = document.getElementById("brake4").offsetTop;
      if (scrollTop + this.screenHeight > topPos) {
        this.animate = true;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  height: 368px;
  background-color: pink;
  color: #fff;
  margin: 0 auto;
  background: url('~@/assets/image/brake/brake4/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.inner {
  position: absolute;
  width: 188px;
  height: 117px;
  left: 206px;
  top: 126px;
}
</style>